var owners = {};

owners = {
  sing: "Eigentümer",
  plu: "Eigentümer",
  h_plu: "Eigentümer - Übersicht",
  h_sing: "Eigentümer - Detailansicht",
}

export default owners;